import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=33a3dd69&scoped=true&"
import script from "./main-header.vue?vue&type=script&lang=js&"
export * from "./main-header.vue?vue&type=script&lang=js&"
import style0 from "./main-header.vue?vue&type=style&index=0&id=33a3dd69&prod&lang=scss&"
import style1 from "./main-header.vue?vue&type=style&index=1&id=33a3dd69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3dd69",
  null
  
)

export default component.exports